export default __webpack_public_path__ + "media/images/bottom_cta_bg-1b21d2d7d654b4e37755eba8f1ab61b2.png";